<template lang="pug">
  v-footer(padless)
    .d-flex.flex-row
      a(
        href="/tnc"
      ) Terms & Conditions
      a &#124;
      a(
        href="/policy"
      ) Privacy Policy
      a(class="d-none d-lg-flex") &#124;
    a
      v-icon mdi-copyright
      b.ml-2 2021 By 
        a(href="https://www.codafuture.com") Codafuture Sdn Bhd
    a(class="d-none d-lg-flex") &#124;
    .d-flex.flex-row
      a(
        href="/contact"
      ) Contact Us
      a &#124;
      a
        v-icon(
          size="24px"
        ) mdi-facebook
      a
        v-icon(
          size="24px"
        ) mdi-instagram
</template>

<script>
export default {
  watch: {

  },
  computed: {

  }
};
</script>
